export const editFirmAction = {
  edit: () => ({
    type: 'edit',
  }),
  noedit: () => ({
    type: 'noedit',
  }),
};
